export var metadatas = [{
  id: 'commission',
  label: 'Comisión',
  tooltip: {
    title: 'Comisión',
    text: 'Porcentaje del capital invertido que se ha de pagar por la compra o venta del producto, su gestión, su custodia...'
  }
}, {
  id: 'facts',
  label: 'Destacado'
}, {
  id: 'topic',
  label: 'Temática',
  tooltip: {
    title: 'Temática',
    text: 'En qué sector temático se está invirtiendo la mayor parte de la cartera.'
  }
}, {
  id: 'region',
  label: 'Región',
  tooltip: {
    title: 'Zona geográfica',
    text: "Pa\xEDs, \xE1rea o zona geogr\xE1fica en la que invierte el producto."
  }
}, {
  id: 'index',
  label: 'Índice',
  tooltip: {
    title: 'Índice de referencia',
    text: "Conjunto de activos que el producto toma como referencia para replicarlo. La rentabilidad de fondo e \xEDndice ser\xE1 similar."
  }
}, {
  id: 'card_type',
  label: 'Tipo',
  tooltip: {
    title: 'Tipo',
    text: 'Tarjeta de débito o de crédito.'
  }
}, {
  id: 'type',
  label: 'Tipo',
  tooltip: {
    title: 'Tipo',
    text: 'Tipo.'
  }
}, {
  id: 'card_company',
  label: 'Compañía',
  tooltip: {
    title: 'Compañía',
    text: "Compa\xF1\xEDa fabricante de la tarjeta."
  }
}, {
  id: 'emission_comission',
  label: 'Comisión de emisión',
  unit: 'currency',
  tooltip: {
    title: 'Comisión de emisión',
    text: 'Comisiones que cobra la empresa emisora de la tarjeta.'
  }
}, {
  id: 'complexity',
  label: 'Complejidad',
  tooltip: {
    title: 'Complejidad',
    text: 'Nivel de complejidad en el uso de la wallet.'
  }
}, {
  id: 'format',
  label: 'Formato',
  tooltip: {
    title: 'Formato',
    text: 'Existen carteras frías (hardware) y carteras calientes (online).'
  }
}, {
  id: 'protection',
  label: 'Nivel de protección',
  tooltip: {
    title: 'Seguridad',
    text: 'Nivel de protección de la wallet frente a ataques informáticos.'
  }
}, {
  id: 'expected_return',
  label: 'Rentabilidad esperada*',
  tooltip: {
    title: 'Rentabilidad esperada*',
    text: 'Rentabilidad que la empresa comercializadora estima que puede llegar a conseguir el activo.'
  }
}, {
  id: 'liquidity',
  label: 'Liquidez',
  tooltip: {
    title: 'Liquidez',
    text: 'Facilidad para disponer de la inversión.'
  }
}, {
  id: 'country',
  label: 'País',
  tooltip: {
    title: 'País',
    text: 'País.'
  }
}, {
  id: 'sector',
  label: 'Sector',
  tooltip: {
    title: 'Sector',
    text: 'En qué sector se está invirtiendo.'
  }
}, {
  id: 'ranking',
  label: 'Ranking',
  tooltip: {
    title: 'Ranking',
    text: 'Posición de la cripto en el mercado por valoración.'
  }
}, {
  id: 'market',
  label: 'Mercado',
  tooltip: {
    title: 'Mercado',
    text: 'El mercado en el que opera puede ser un mercado regulado o un mercado no regulado.'
  }
}, {
  id: 'product',
  label: 'Producto',
  tooltip: {
    title: 'Producto',
    text: 'Existen diferentes productos y fondos cotizados: ETF ETP, ETN.'
  }
}, {
  id: 'performance_m0',
  label: 'Rent. YTD',
  unit: 'percent',
  tooltip: {
    title: 'Rentabilidad YTD',
    text: 'Beneficio o pérdida obtenido de una inversión en un determinado período de tiempo.'
  }
}, {
  id: 'performance_m12',
  label: 'Rent. 12 meses',
  unit: 'percent',
  tooltip: {
    title: 'Rentabilidad a 12 meses',
    text: 'Beneficio o pérdida obtenido de una inversión en un determinado período de tiempo.'
  }
}, {
  id: 'minimum_initial_subscription_amount',
  label: 'Inversión mínima inicial',
  unit: 'currency'
}, {
  id: 'minimum_subscription_amount',
  label: 'Aportaciones periódicas mínimas'
}, {
  id: 'strategy',
  label: 'Estrategia de inversión'
}, {
  id: 'management_fee',
  label: 'Comisión de gestión'
}, {
  id: 'management_success_fee',
  label: 'Comisión de éxito',
  unit: 'percent'
}, {
  id: 'instruments_fee',
  label: 'Comisión de fondos + custodia'
}, {
  id: 'maximum_fee',
  label: 'Comisión máxima'
}, {
  id: 'net_assets',
  label: 'Patrimonio bajo gestión'
}, {
  id: 'custodian',
  label: 'Entidad custodia'
}, {
  id: 'pros',
  label: 'Ventajas'
}, {
  id: 'cons',
  label: 'Desventajas'
}, {
  id: 'mobile_app',
  label: 'Aplicación móvil'
}, {
  id: 'buy_online',
  label: 'Contratación por Internet'
}, {
  id: 'author',
  label: 'Autor'
}, {
  id: 'term',
  label: 'Plazo'
}, {
  id: 'roboadvisor',
  label: 'Es roboadvisor'
}, {
  id: 'platform',
  label: 'Plataforma'
}, {
  id: 'price',
  label: 'Precio'
}, {
  id: 'artist',
  label: 'artista'
}, {
  id: 'performance_2021',
  unit: 'percent',
  label: ['Rentabilidad', '2021']
}, {
  id: 'performance_2020',
  unit: 'percent',
  label: ['Rentabilidad', '2020']
}, {
  id: 'buy_in',
  label: 'Comprar en'
}, {
  id: 'method',
  label: 'Modalidad'
}, {
  id: 'duration',
  label: 'Duración'
}, {
  id: 'level',
  label: 'Nivel',
  tooltip: {
    title: 'Nivel',
    text: 'Nivel de dificultad del curso.'
  }
}, {
  id: 'taught_by',
  label: 'Impartido por',
  tooltip: {
    title: 'Impartido por',
    text: 'Qué entidad imparte el curso.'
  }
}, {
  id: 'apr',
  label: 'TAE',
  tooltip: {
    title: 'TAE',
    text: 'Tasa anual equivalente.'
  }
}];